import { ValueGetterParams } from '@ag-grid-community/core';
import {
    TransactionTypeString,
    transactionTypeCharMap
} from '@tassat/common-definitions';

interface GetInitiatorBalanceWithCurrencyProps extends ValueGetterParams {
    data: any;
}

export const getInitiatorBalanceWithCurrency = (props: GetInitiatorBalanceWithCurrencyProps) => {
    const { data } = props;
    const tranType: string = (transactionTypeCharMap(data.type) as string);
    let senderBalance = true;

    if (
        tranType === TransactionTypeString.receive
    ) {
        senderBalance = false;
    }

    const balance = senderBalance ? data.SenderAvailableBalance : data.RecipientAvailableBalance;

    return ({
        Amount: balance,
        Ticker: data.Ticker,
        Currency: data.CurCode
    });
};